import { cn } from '@tripleten/cn';

export const cnRegister = cn('register');
